// extracted by mini-css-extract-plugin
export default {"cls1":"LoadingSheet-Container-module--cls1--d4gEf","cls2":"LoadingSheet-Container-module--cls2--ISePE LoadingSheet-Container-module--cls1--d4gEf"};